import { cn } from "@/libs/cn";

const gridCols = "md:grid-cols-[1fr_3fr_2fr_1fr] md:gap-4";
export const gridLayout = cn("flex flex-col gap-2 md:grid md:items-center", gridCols, "px-4 md:px-6 py-3 md:py-2");

export const SKELETON_COLUMNS = 4;

const LogListHeader = () => {
  const headerStyle = "text-sm text-ui-navy-dark font-semibold text-gray-500 uppercase";

  return (
    <div className={cn("hidden md:grid md:items-center", gridCols, "bg-white border-b border-gray-100 px-6 py-4")}>
      <span className={headerStyle}>Usuário</span>
      <span className={headerStyle}>Operação</span>
      <span className={headerStyle}>Origem</span>
      <span className={headerStyle}>Data</span>
    </div>
  );
};

export default LogListHeader;
